import React, { useState } from "react";
import { toast } from "sonner";
import { HOME } from "@/constants/testIds";

// Site origin — used for building the share link (falls back to current origin)
const siteOrigin = () =>
  typeof window !== "undefined" ? window.location.origin : "https://www.li-f.live";

export const SharePanel = ({ code, nome }) => {
  const url = `${siteOrigin()}/?ref=${encodeURIComponent(code)}`;
  const nomePart = nome ? `${nome} ` : "";
  const message = `${nomePart}ti invita in LIF · Libertà Finanziaria. Evento di lancio 22 Ottobre a Pinerolo. Iscriviti qui con il mio codice ${code}: ${url}`;

  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copiato negli appunti.");
      setTimeout(() => setCopied(false), 2500);
    } catch (_) {
      toast.error("Copia manuale del link necessaria.");
    }
  };

  const encMsg = encodeURIComponent(message);
  const encUrl = encodeURIComponent(url);

  const links = [
    {
      id: HOME.shareWhatsapp,
      label: "WhatsApp",
      href: `https://wa.me/?text=${encMsg}`,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 2.09.55 4.07 1.6 5.82L2 22l4.42-1.16a9.87 9.87 0 004.62 1.18c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.02A9.86 9.86 0 0012.04 2m0 1.67c2.19 0 4.25.85 5.8 2.4a8.23 8.23 0 012.4 5.83c0 4.54-3.7 8.25-8.24 8.25a8.2 8.2 0 01-4.19-1.15l-.3-.18-2.63.69.7-2.56-.19-.29a8.21 8.21 0 01-1.26-4.36c0-4.55 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.42.06-.65.31-.22.24-.86.85-.86 2.06 0 1.22.89 2.39 1 2.56.11.16 1.74 2.65 4.25 3.72.6.26 1.07.41 1.44.52.6.19 1.15.16 1.58.1.48-.07 1.49-.61 1.7-1.19.21-.58.21-1.08.14-1.19-.06-.11-.22-.16-.47-.29-.24-.13-1.47-.72-1.69-.8-.22-.08-.39-.13-.55.13-.15.24-.63.79-.77.94-.14.16-.28.18-.53.05-.24-.12-1.04-.37-1.98-1.22-.73-.65-1.24-1.46-1.38-1.71-.15-.24-.02-.38.1-.51.11-.11.24-.29.36-.42.13-.14.17-.24.26-.4.09-.16.05-.31-.01-.44-.08-.12-.55-1.34-.75-1.82-.19-.47-.39-.4-.53-.41H8.53z" />
        </svg>
      ),
    },
    {
      id: HOME.shareTelegram,
      label: "Telegram",
      href: `https://t.me/share/url?url=${encUrl}&text=${encMsg}`,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.24 3.64 11.9c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.7L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" />
        </svg>
      ),
    },
    {
      id: HOME.shareEmail,
      label: "Email",
      href: `mailto:?subject=${encodeURIComponent(
        "Ti invito in LIF — Libertà Finanziaria"
      )}&body=${encMsg}`,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="M3 7l9 6 9-6" />
        </svg>
      ),
    },
    {
      id: HOME.shareFacebook,
      label: "Facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${encUrl}`,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M13.5 21v-8h2.7l.4-3.13H13.5V7.9c0-.9.25-1.52 1.55-1.52h1.65V3.57A22 22 0 0014.29 3.4c-2.4 0-4.04 1.46-4.04 4.14v2.33H7.5V13h2.75v8z" />
        </svg>
      ),
    },
    {
      id: HOME.shareX,
      label: "X",
      href: `https://twitter.com/intent/tweet?text=${encMsg}`,
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M18.244 2H21.5l-7.44 8.505L22.5 22h-6.828l-5.355-6.99L4.2 22H.938l7.93-9.062L.5 2h6.99l4.83 6.373L18.244 2zm-1.198 18.2h1.88L7.06 3.7H5.04l12.006 16.5z" />
        </svg>
      ),
    },
  ];

  return (
    <div className="mt-8">
      <p className="eyebrow eyebrow-light mb-4">Invita un amico</p>

      {/* URL preview + copy */}
      <div className="flex items-center gap-2 bg-[color:var(--lif-light-bg)] border border-[color:var(--lif-light-line)] rounded-md px-4 py-3">
        <span className="flex-1 font-mono text-[13px] tracking-[0.02em] text-[color:var(--lif-light-fg)] truncate">
          {url}
        </span>
        <button
          type="button"
          onClick={copy}
          data-testid={HOME.shareCopy}
          className="font-mono text-[10px] tracking-[0.22em] uppercase px-3 py-2 rounded bg-[color:var(--lif-light-fg)] text-white hover:bg-[color:var(--lif-accent)] hover:text-[color:var(--lif-light-fg)] transition-colors flex-shrink-0"
        >
          {copied ? "Copiato" : "Copia"}
        </button>
      </div>

      {/* Social buttons */}
      <div className="mt-4 grid grid-cols-5 gap-2">
        {links.map((l) => (
          <a
            key={l.label}
            href={l.href}
            target="_blank"
            rel="noreferrer"
            data-testid={l.id}
            aria-label={`Condividi su ${l.label}`}
            className="group flex flex-col items-center justify-center gap-1.5 py-3 border border-[color:var(--lif-light-line)] rounded-md hover:border-[color:var(--lif-light-fg)] hover:bg-[color:var(--lif-light-bg)] transition-colors text-[color:var(--lif-light-fg)]"
          >
            {l.icon}
            <span className="font-mono text-[9px] tracking-[0.18em] uppercase text-[color:var(--lif-light-fg-2)] group-hover:text-[color:var(--lif-light-fg)]">
              {l.label}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SharePanel;
